module.exports = "/_next/static/images/33-1-206ecb464e45387d984281d2ad61a760.jpg";